"use client"
import { useEffect, useState } from "react"
import { appendUtmParams } from "./appendUtmParams"
import { getNonUmbracoUrl } from "./getNonUmbracoUrl"

/**
 * Custom hook that handles URL generation with UTM parameters while preventing hydration errors.
 *
 * @returns A function that takes a URL and returns it with UTM parameters appended (client-side only)
 *
 * @example
 * ```tsx
 * const getUrlWithUtm = useUtmUrl()
 *
 * // Usage in component
 * <ButtonWithArrow href={getUrlWithUtm("/some-page")} />
 * ```
 */
export function useUtmUrl() {
  // State to track if component is mounted (client-side)
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  // Function to get href with UTM params only on client side
  const getUrlWithUtm = (url: string) => {
    if (!url) {
      return url
    }
    if (!isMounted) {
      // Server-side: return URL without UTM params
      return getNonUmbracoUrl(url)
    }
    // Client-side: return URL with UTM params
    return appendUtmParams(getNonUmbracoUrl(url))
  }

  return getUrlWithUtm
}
